import { render } from "./CreditItem.vue?vue&type=template&id=10742dd6&scoped=true"
import script from "./CreditItem.vue?vue&type=script&lang=js"
export * from "./CreditItem.vue?vue&type=script&lang=js"

import "./CreditItem.vue?vue&type=style&index=0&id=10742dd6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10742dd6"],['__file',"src/views/MyAccount/MyRedemption/components/CreditItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10742dd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10742dd6', __exports__)) {
    console.log('reload')
    api.reload('10742dd6', __exports__)
  }
  
  module.hot.accept("./CreditItem.vue?vue&type=template&id=10742dd6&scoped=true", () => {
    console.log('re-render')
    api.rerender('10742dd6', render)
  })

}


export default __exports__